import { useState } from "react";
import Table from "../../components/table/table";
import { TbDotsVertical } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import EditIcon from "../../icons/editIcon";
import StarIcon from "../../icons/starIcon";
import DeleteIcon from "../../icons/deleteIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/dropDownMenu/dropdown-menu";
import Checkbox from "../../components/inputs/checkbox";
const MembersTable = ({
  t,
  setSelected,
  setOpenView,
  setOpenEdit,
  setOpenRequest,
  setOpenDelete,
}) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const handleCheck = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleCheckAll = () => {
    if (selectedIds.length === members.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(members.map((m) => m.id));
    }
  };
  const handleClick = (m, setState) => {
    setState(true);
    setSelected(m);
  };
  const members = [
    {
      id: 1,
      fullName: "هشام المدير أحمد",
      memberNumber: "CLB-02345",
      type: "VIP",
      status: "فعالة",
      joinDate: "12/06/2023",
    },
    {
      id: 2,
      fullName: "هشام المدير أحمد",
      memberNumber: "CLB-02345",
      type: "VIP",
      status: "فعالة",
      joinDate: "12/06/2023",
    },
    {
      id: 3,
      fullName: "خالد محمود",
      memberNumber: "CLB-01012",
      type: "عائلي",
      status: "قيد المراجعة",
      joinDate: "10/01/2022",
    },
    {
      id: 4,
      fullName: "سارة عمر",
      memberNumber: "CLB-01923",
      type: "شبابي",
      status: "منتهية",
      joinDate: "25/05/2024",
    },
    {
      id: 5,
      fullName: "هشام المدير أحمد",
      memberNumber: "CLB-02345",
      type: "VIP",
      status: "فعالة",
      joinDate: "12/06/2023",
    },
    {
      id: 6,
      fullName: "هشام المدير أحمد",
      memberNumber: "CLB-02345",
      type: "VIP",
      status: "فعالة",
      joinDate: "12/06/2023",
    },
    {
      id: 7,
      fullName: "هشام المدير أحمد",
      memberNumber: "CLB-02345",
      type: "VIP",
      status: "فعالة",
      joinDate: "12/06/2023",
    },
    {
      id: 8,
      fullName: "خالد محمود",
      memberNumber: "CLB-01012",
      type: "عائلي",
      status: "قيد المراجعة",
      joinDate: "10/01/2022",
    },
    {
      id: 9,
      fullName: "سارة عمر",
      memberNumber: "CLB-01923",
      type: "شبابي",
      status: "منتهية",
      joinDate: "25/05/2024",
    },
  ];

  const tableHead = [
    {
      header: (
        <Checkbox
          checked={selectedIds.length === members.length}
          onChange={handleCheckAll}
          id={"members-all"}
        />
      ),
      accessorKey: "check",
    },
    {
      header: t("fullName"),
      accessorKey: "fullName",
    },
    {
      header: t("membershipNumber"),
      accessorKey: "membershipNumber",
    },
    {
      header: t("membershipType"),
      accessorKey: "membershipType",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
    {
      header: t("joinDate"),
      accessorKey: "joinDate",
    },
    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const tableData = members.map((m, i) => {
    const check = (
      <Checkbox
        checked={selectedIds.includes(m.id)}
        onChange={() => handleCheck(m.id)}
        id={`member-${i}`}
      />
    );
    const statusColor =
      m.status === "منتهية"
        ? "#902929"
        : m.status === "قيد المراجعة"
        ? "#D1A855"
        : "#11A849";
    const status = (
      <span
        style={{ backgroundColor: statusColor }}
        className="px-2 py-1 text-white rounded-lg"
      >
        {m.status}
      </span>
    );
    const actions = (
      <div className="relative mx-auto w-fit">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <TbDotsVertical />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenView)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("showDetails")}
                <IoEyeOutline size={24} />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenEdit)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("editInfo")}
                <EditIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenRequest)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("acceptRequest")}
                <StarIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenDelete)}
                className="flex items-center gap-2 justify-end w-full text-[#FF5151] px-4 py-2 text-right hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("deleteMember")}
                <DeleteIcon />
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
    return {
      check,
      fullName: m.fullName,
      membershipNumber: m.memberNumber,
      membershipType: m.type,
      status,
      joinDate: m.joinDate,
      actions,
    };
  });
  return <Table TableData={tableData} TableHead={tableHead} />;
};

export default MembersTable;
